export default __webpack_public_path__ + "be561c2bea1d1a09d93037c45ffb7002.png";